import { layers } from 'app/spacing';
import styled from '@emotion/styled';
import Loader from 'components/Kizen/Loader';

export const ChartLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Chart = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  margin-top: 5px;
  margin-left: -15px;
  margin-right: -34px;
  margin-bottom: -10px;
`;

export const StyledLoader = styled(Loader)`
  position: absolute;
  top: 0;
  left: -15px;
  right: -15px;
  bottom: 5px;
  padding-top: 0 !important;
  background-color: var(--color-background-white);
  z-index: ${layers.content(10)};

  & > div {
    margin-top: 10%;
    margin-right: 10px;
  }
`;
